import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { selectSpaceInfoItem } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';
import { currentUserIsOwnerOrAdmin } from '~src/spacesPlatform/utils/MixedContentHelpers';

import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import { changeRemoteExtractRefresh } from '../actions/ChangeRemoteExtractRefreshAction';
import { IRemoteRefreshScheduleInfo } from '../models/IRemoteRefreshScheduleInfo';

export const ChangeRemoteExtractRefreshEntityAction:
  IEntityAction<IRemoteRefreshScheduleInfo, any> = {
  name: EntityActionNames.TasksEdit,
  translateName: Messages.changeFrequency_action,
  isVisible: () => true,
  isClickable: isClickable,
  createReduxAction: (items: IRemoteRefreshScheduleInfo[]) => changeRemoteExtractRefresh(items[0])
};

function isClickable(
  availableActions: any,
  schedules: IRemoteRefreshScheduleInfo[],
  state: AppState
): boolean {
  const spaceItem = selectSpaceInfoItem(state);
  return currentUserIsOwnerOrAdmin(state, spaceItem);
}
